<template>
  <nav>
    <Grid>
      <a href="#" class="btn btn-lang">HTD</a>
      <span class="btn btn-menu" v-on:click="toggleActiveFlyout">Menu</span>
    </Grid>
    <div class="overlay" v-bind:class="{ active: activeFlyout }" v-scroll="disableFlyout"></div>
    <div class="flyout" v-bind:class="{ active: activeFlyout }">
      <div class="left">
        <router-link to="/" class="btn">
          <strong>Home</strong>
        </router-link>
        <a class="btn close" v-on:click="disableFlyout">
          <Close>Close</Close>
        </a>
      </div>
      <div class="right">
        <router-link to="/act-like-a-designer" class="btn">
          <strong class="count">1</strong> Act like a designer
        </router-link>
        <router-link to="/getting-practical" class="btn">
          <strong class="count">2</strong> Getting practical
        </router-link>
      </div>
    </div>
  </nav>
</template>
<script>
import Grid from "./Grid.vue";
import Close from "./Close.vue";
export default {
  name: "Nav",
  components: {
    Grid,
    Close
  },
  data: function() {
    return {
      activeFlyout: false
    };
  },
  methods: {
    disableFlyout: function() {
      this.activeFlyout = false;
    },
    toggleActiveFlyout: function() {
      this.activeFlyout = !this.activeFlyout;
    }
  }
};
</script>
<style scoped>
.grid {
  z-index: 6000;
}

nav {
}
nav::after {
  content: " ";
  background-color: #1c5cf7;
  top: 0;
  left: 0;
  right: 0;
  bottom: -400px;
  position: absolute;
  z-index: 4000;
}

nav::before {
  content: " ";
  background-color: #1a4abe;
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
  height: calc(var(--LINE-HEIGHT) * 2);
  width: calc(var(--WIDTH) - var(--SPACE-RIGHT));
  position: absolute;
  z-index: 5000;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(var(--LINE-HEIGHT) * 4);
  background-color: var(--WHITE);
  z-index: 2000;
  opacity: 0;
  pointer-events: none;
  transition: var(--TRANSITION);
}
.overlay.active {
  opacity: 1;
}

.flyout {
  width: calc(var(--WIDTH) - var(--SPACE-LEFT) - var(--SPACE-RIGHT));
  height: calc(var(--LINE-HEIGHT) * 11);
  padding-left: var(--SPACE-LEFT);
  margin-right: var(--SPACE-RIGHT);
  position: fixed;
  justify-content: flex-end;
  left: 0;
  background-color: #2c2f34;
  bottom: calc(var(--LINE-HEIGHT) * 4);
  display: flex;
  color: var(--WHITE);
  font-size: 20px;
  transform: translateY(calc(var(--LINE-HEIGHT) * 11));
  z-index: 3000;
  transition: var(--TRANSITION);
}

.flyout.active {
  transform: translateY(0);
  opacity: 1;
}

@media only screen and (max-width: 576px) {
  .flyout {
    height: calc(100 * var(--vh) - calc(var(--LINE-HEIGHT) * 16));
    min-height: calc(var(--LINE-HEIGHT) * 11);
    padding-right: 25px;
    flex-direction: column;
    justify-content: space-between;
    transform: translateY(100%);
  }
  nav::before {
    right: 0;
    width: auto;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .flyout {
    padding-right: 25px;
  }
  nav::before {
    right: 0;
    width: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
}
@media only screen and (min-width: 992px) {
}

.flyout strong {
  font-weight: bold;
}

.flyout {
  stroke: var(--WHITE);
}

.flyout .left {
  width: calc(4 * var(--COLUMN-SIZE) - var(--EXTRA-SPACE-LEFT));
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: var(--LINE-HEIGHT);
  position: relative;
}
@media only screen and (max-width: 576px) {
  .flyout .left {
    padding-top: calc(var(--LINE-HEIGHT) * 2);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
}
@media only screen and (min-width: 992px) {
}

.flyout .right {
  width: calc(4 * var(--COLUMN-SIZE));
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
  padding-bottom: var(--LINE-HEIGHT);
}

.flyout .btn {
  line-height: var(--LINE-HEIGHT);
  padding-bottom: var(--LINE-HEIGHT);
  flex-shrink: 0;
  letter-spacing: -0.3px;
  color: inherit;
  text-decoration: none;
}

.flyout .btn.close {
  height: var(--LINE-HEIGHT);
  width: 28px;
  position: absolute;
  top: var(--LINE-HEIGHT);
  overflow: hidden;
  right: -28px;
}

@media only screen and (max-width: 576px) {
  .flyout .btn.close {
    height: var(--LINE-HEIGHT);
    width: 28px;
    position: absolute;
    top: calc(var(--LINE-HEIGHT) * 1.3);
    overflow: hidden;
    right: auto;
    right: 0;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
}
@media only screen and (min-width: 992px) {
}

.flyout strong.count {
  padding-right: 15px;
}

nav {
  position: fixed;
  height: calc(var(--LINE-HEIGHT) * 4);
  background-color: var(--GREY);
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5000;
}

nav .btn {
  cursor: pointer;
}

nav .btn-lang {
  font-weight: bold;
  text-decoration: none;
  color: #000;
  font-size: 20px;
  padding-top: 0px;
  margin-left: var(--EXTRA-SPACE-LEFT);
  line-height: calc(2 * var(--LINE-HEIGHT));
}

nav .btn-menu {
  height: calc(2 * var(--LINE-HEIGHT));
  width: 50.4px;
  position: absolute;
  top: 0;
  text-indent: -3000px;
}

nav .btn-menu::after {
  content: " ";
  position: absolute;
  height: 3.1px;
  right: 0;
  top: calc(var(--LINE-HEIGHT));
  background-color: #000;
  width: 15.27px;
  pointer-events: none;
}

nav .btn-menu::before {
  content: " ";
  position: absolute;
  height: 3.1px;
  left: 0;
  top: calc(var(--LINE-HEIGHT));
  background-color: #000;
  width: 30px;
  pointer-events: none;
}

@media only screen and (max-width: 576px) {
  nav .btn-lang {
    margin-left: var(--EXTRA-SPACE-LEFT);
    font-size: 18px;
  }
  nav .btn-menu {
    left: auto;
    right: 0;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  nav .btn-menu {
    left: calc(2 * var(--COLUMN-SIZE));
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  nav .btn-menu {
    left: calc(4 * var(--COLUMN-SIZE));
  }
}

@media only screen and (min-width: 992px) {
  nav .btn-menu {
    left: calc(4 * var(--COLUMN-SIZE));
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue